// A Zhuyin IME leaves bare Bopomofo in the field until the syllable is committed to a Han character.
const ZHUYIN = /\p{Script=Bopomofo}/u

export function hasZhuyin(text) {
  return ZHUYIN.test(text)
}
